import { callApi } from "../callApi"

export const deletePartnerUuidFleetsUuid = async (partnerUuid: string, fleetUuid: string) =>
  callApi<null, null>({
    method: "DELETE",
    path: `/partner/${partnerUuid}/fleets/${fleetUuid}`,
  })
